import React from "react";

function ListItem({ item }) {
  // console.log(item);
  const styles = {
    statuscode: {
      backgroundColor: "red",
      color: "#fff",
    },
  };
  switch (item.status.toLowerCase()) {
    case "operational":
      styles.statuscode.backgroundColor = "#33a851";
      break;
    case "major_outage":
      styles.statuscode.backgroundColor = "#FF033E";
      break;
    case "partial_outage":
      styles.statuscode.backgroundColor = "#FF9900";
      styles.statuscode.color = "#253858";
      break;
    case "degraded_performance":
      styles.statuscode.backgroundColor = "#fbae40";
      styles.statuscode.color = "#253858";
      break;
    case "partial_outage":
      styles.statuscode.backgroundColor = "#fbae40";
      styles.statuscode.color = "#253858";
      break;
    case "under_maintenance":
      styles.statuscode.backgroundColor = "#0088ff";
      break;
    default:
      styles.statuscode.backgroundColor = "black";
  }

  function StrFunc(str) {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  }

  const status = StrFunc(item.status);

  return (
    <div className="item" key={item.id}>
      <div className="item-name">{item.name}</div>
      <div style={styles.statuscode} className="item-status">
        {status}
      </div>
    </div>
  );
}

export default ListItem;
